import api from './api';

export interface DealerLocation {
  id: string;
  name: string;
  address?: string | null;
  city: string;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  website?: string | null;
}

export const getDealerLocations = async (): Promise<DealerLocation[]> => {
  const response = await api.get<DealerLocation[]>('/public/dealers');
  return response.data;
};

export interface DealerApplicationRequest {
  companyName: string;
  contactName: string;
  email: string;
  phone?: string;
  website?: string;
  address: string;
  country: string;
  message?: string;
}

export const submitDealerApplication = async (data: DealerApplicationRequest) => {
  const response = await api.post('/public/dealer-application', data);
  return response.data;
};

export interface DeliveryTimes {
  CLIP: number;
  COMPLETE_GLASSES: number;
}

export const getDeliveryTimes = async (): Promise<DeliveryTimes> => {
  const response = await api.get<DeliveryTimes>('/public/delivery-times');
  return response.data;
};
